import { c as _c } from "react/compiler-runtime";
import type { MapData, MapDataLocationFeature } from '@repo/types/maps/map-types';
import { getNearbyPins } from '@repo/types/maps/map-utils';
import { useMemo } from 'react';
const MIN_LEVEL = 4;
const ABSOLUTE_MAX_LEVEL = 10;
const MAX_RESULTS_WHEN_BUMPED = 25;
export function useExploreNearbyPins(anchorPin, mapData) {
  const $ = _c(2);
  let t0;
  bb0: {
    if (!anchorPin || !mapData) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    for (let level = MIN_LEVEL; level <= ABSOLUTE_MAX_LEVEL; level++) {
      const pins = getNearbyPins({
        points: mapData.geojson.features,
        referencePoint: anchorPin,
        proximityLevel: level
      });
      if (pins.length === 0) {
        continue;
      }
      t0 = level > MIN_LEVEL ? pins.slice(0, MAX_RESULTS_WHEN_BUMPED) : pins;
      break bb0;
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [];
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  return t0;
}